module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/zen-observable/index.js
// module id = 1954
// module chunks = 69